import { render, staticRenderFns } from "./PublisherPagesGroup.vue?vue&type=template&id=34727541&scoped=true&"
import script from "./PublisherPagesGroup.vue?vue&type=script&lang=js&"
export * from "./PublisherPagesGroup.vue?vue&type=script&lang=js&"
import style0 from "./PublisherPagesGroup.vue?vue&type=style&index=0&id=34727541&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34727541",
  null
  
)

export default component.exports